import { observer } from "mobx-react-lite"
import { useStore } from "../../../app/stores/store";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import UnauthorizedMessage from "../../UnauthorizedMessage";
import TableComponent from "./TableComponent";
import { useEffect } from "react";
 function ClusterReport () {
  const { RestorationStore, dashboardStore, commonStore } = useStore();
  useEffect(()=>{
    RestorationStore.HandleClusterHeadEmployeeID();
    // eslint-disable-next-line
  },[]);
  const dateBasedApiCall = async (fromDate?: string, toDate?: string,clusterEmployeeId?:string) => {
    await RestorationStore.ClusterWiseDateReport(
      fromDate || '',
      toDate || '',
      clusterEmployeeId || ''
    );  
  };
  return (
    <div>
      {dashboardStore.dashboard.loadingdata === 'loading' && (
        <div style={{ marginTop: '30px' }}>
          <LoadingComponent />
        </div>
      )}
      {dashboardStore.dashboard.loadingdata !== 'loading' &&
        !commonStore.filterModeOne?.includes('CWR01') && (
          <UnauthorizedMessage />
        )}
      {commonStore.filterModeOne?.includes('CWR01') && (  
        <TableComponent
          name={'Cluster Report'}
          dateBasedApiCall={dateBasedApiCall}
          DateInput={true}
          DualInut={false}
          downloadName={'Cluster Report'}
          clusterEmployeeIdFilter={true}
        />
      )}
    </div>
)
}
export default observer(ClusterReport);